import { createSlice } from "@reduxjs/toolkit";
import { searchPhysioServices } from "../../reducer/searchPhysioServices/searchPhysioServicesReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const searchPhysioServicesSlice = createSlice({
  name: "searchPhysioServices",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(searchPhysioServices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchPhysioServices.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(searchPhysioServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default searchPhysioServicesSlice.reducer;
